import React from "react";

export default function RelatedBlog() {
  return <section></section>;
}
